export default {
    bind(el, binding) {
        el.innerText = binding.value;

        el.addEventListener('click', () => {
            if (el.innerText === '[Text here]') {
                document.execCommand('selectAll', false, null);
            }
        });

        el.addEventListener('blur', () => {
            if (el.innerText === '') {
                el.innerText = '[Text here]';
            }
        });
    },

    unbind(el) {
        el.removeEventListener('click', () => {
            if (el.innerText === '[Text here]') {
                document.execCommand('selectAll', false, null);
            }
        });

        el.removeEventListener('blur', () => {
            if (el.innerText === '') {
                el.innerText = '[Text here]';
            }
        });
    },
};
